import { h } from '../utils/dom.js';

export const Tooltip = (text, content) => {
  if (!text) return content;
  const wrap = h('div', { class: 'tooltip-wrap' });
  wrap.appendChild(content);
  wrap.appendChild(h('span', { class: 'tooltip' }, text));
  return wrap;
};

export const withTooltip = (el, text) => {
  if (!text) return el;
  el.setAttribute('aria-label', text);
  const wrap = h('div', { class: 'tooltip-wrap' });
  const tip = h('span', { class: 'tooltip' }, text);
  wrap.appendChild(el);
  wrap.appendChild(tip);
  return wrap;
};
